<div *ngFor="let therapyTypeInfo of componentProps.therapyTypeInfos" class="therapies">
  <div *ngIf="therapyTypeInfo.integratedCare?.status === 1" class="therapy-info">
    <itl-detail-title-therapy-icon [therapyId]="therapyTypeInfo.integratedCare?.therapyId">
    </itl-detail-title-therapy-icon>
    <div class="therapy">
      <div class="name" [style.color]="therapyTypeInfo.integratedCare?.therapyId | therapyColor">
        {{ therapyTypeInfo.integratedCare.therapyId | therapy }}
      </div>
      <div class="therapy-type">
        {{ therapyTypeInfo.integratedCare?.therapyTypeId | therapyType }}
      </div>
    </div>
    <ion-checkbox
      color="secondary-variant-alberta"
      class="selectTherapy"
      (ionChange)="selectTherapy($event, therapyTypeInfo.integratedCare)"
    ></ion-checkbox>
  </div>
</div>
